/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

export type DeviceRemoteActionsControllerFindAllParams = {
  /**
   * Optional device ID to filter remote actions for a specific device
   */
  deviceId?: string;
};
